import { Card, CardContent, CardDescription, CardHeader, CardMeta, Icon, Image } from "semantic-ui-react";
import styles from './MainPage.module.css';

const Card2 = () => {

    return (
        <Card fluid className={styles.cardShadow}>
            <CardContent>
                <CardHeader><center>Трюфельный тур и охота</center></CardHeader>
                <CardMeta>
                    <a href="/tours"><Image src="./assets/tourlogo.png" fluid centered /></a>
                </CardMeta>
            </CardContent>
        </Card>
    );
}

export default Card2